import * as React from "react";
import {
  Box,
  Container,
  Grid,
  Header,
  Link,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import { Funding, ServiceItem } from "../../../calcBusterTypes";
import EligibleServicesBarChart from "./EligibleServicesBarChart";
import AnnualRunRateMetrics from "./AnnualRunRateMetrics";
import EligibleServicesTable from "./EligibleServicesTable";
import config from "../../../config";

const EligibleServicesTab: React.FC<{
  funding: Funding;
  services: ServiceItem[];
}> = ({ funding, services }) => {
  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Eligible Services vs Non Eligible Services"
        >
          MAP Eligible Services
        </Header>
      }
    >
      <SpaceBetween size="l">
        <Box>
          <b>Eligible Services</b> are services that can be tagged and generate
          credit according to the MAP program guide{" "}
          <Link href={config.MAP_ELIGIBLE_LIST}>(eligible services)</Link>
        </Box>

        <Grid
          gridDefinition={[
            {
              colspan: {
                default: 12,
                xs: 12,
                s: 12,
                m: 6,
                l: 6,
                xl: 6,
              },
            },
            {
              colspan: {
                default: 12,
                xs: 12,
                s: 12,
                m: 6,
                l: 6,
                xl: 6,
              },
            },
          ]}
        >
          <EligibleServicesBarChart funding={funding} />

          <AnnualRunRateMetrics funding={funding} />
        </Grid>

        <EligibleServicesTable services={services} />
      </SpaceBetween>
    </Container>
  );
};

export default EligibleServicesTab;
